//* 이벤트 관련 API
import * as BaseApi from "api/Base.api";
const BASE_URL = "/event";

export interface ISajuAnalysis {
    face_impression: string;
    attractive_points: string;
    suitable_position: string;
    overall_flow: string;
    year_2026_flow: string;
    recommended_direction: string;
}

export interface ISajuMemberResponse {
    eventLog: ISajuAnalysis | null;
}

export interface ISajuAnalysisCreateResponse {
    result: boolean;
    sajuAnalysis: ISajuAnalysis;
    languageCode: string;
}

//* 사주 관상 분석 조회
//  GET /event/saju/member
export const getSajuAnalysis = async (): Promise<ISajuMemberResponse> => {
    console.log('api/student/v2/event.api:getSajuAnalysis');
    const result = await BaseApi.get(`${BASE_URL}/saju/member`);
    // BaseApi.get은 data.data를 반환하므로 result는 { eventLog: {...} } 형태
    if (result) {
        return result;
    }
    throw new Error('사주 관상 분석 조회 실패');
};

//* 사주 관상 분석 생성
//  POST /event/saju/member
export const createSajuAnalysis = async (): Promise<ISajuAnalysisCreateResponse> => {
    console.log('api/student/v2/event.api:createSajuAnalysis');
    const result = await BaseApi.post(`${BASE_URL}/saju/member`, {});
    // BaseApi.post는 { status, data } 형태로 반환
    // result.data가 서버 응답 전체 { message: "성공", data: {...} }
    // result.data.data가 실제 ISajuAnalysisCreateResponse
    if (result && result.status === 200 && result.data && result.data.data) {
        return result.data.data;
    }
    throw new Error('사주 관상 분석 생성 실패');
};

